<template>
  <div class="m-2">
    <canvas ref="my-canvas" style="border: 2px solid black;width:256px;height:256px;"></canvas>
  </div>
</template>
<script>
import eigenValues from "../data/eigenValues.json";
import eigenVectors from "../data/eigenVectors.json";
import mean from "../data/mean.json";
import * as tf from "@tensorflow/tfjs";

export default {
  props: ["allSlidersValues"],
  async mounted() {
    this.model = await tf.loadModel("./model/model.json");
    this.context = this.$refs["my-canvas"].getContext("2d");
    this.$refs["my-canvas"].width = 64;
    this.$refs["my-canvas"].height = 64;
  },
  data() {
    return {
      eigenValues,
      eigenVectors,
      mean,
      model: null,
      context: null
    };
  },
  watch: {
    allSlidersValues: async function(val) {
      if (this.model == null || val == null || val.length == 0) {
        return;
      }
      let recovered_from_pca = mean.slice();
      for (let i = 0; i < val.length; ++i) {
        let eigenVectorsByValues = eigenVectors[i].map(x => x * eigenValues[i]);
        let multipliedByPcaVal = eigenVectorsByValues.map(x => val[i] * x);
        for (let j = 0; j < recovered_from_pca.length; ++j) {
          recovered_from_pca[j] += multipliedByPcaVal[j];
        }
      }
      const tensor = tf.tensor([recovered_from_pca]);
      const result = await this.model.predict(tensor).data();
      // result = y * x * color
      let imageData = this.context.createImageData(64, 64);
      let imageArray = imageData.data;
      for (let x = 0; x < 64; ++x) {
        for (let y = 0; y < 64; ++y) {
          for (let c = 0; c < 3; ++c) {
            imageArray[x * 4 + y * 64 * 4 + c] = parseInt(
              result[x * 3 + y * 64 * 3 + c] * 255
            );
          }
          imageArray[x * 4 + y * 64 * 4 + 3] = 255;
        }
      }
      this.context.putImageData(imageData, 0, 0);
    }
  }
};
</script>